export const FETCH_RECOMMENDATION_REQUEST = 'FETCH_RECOMMENDATION_REQUEST';
export const FETCH_RECOMMENDATION_SUCCESS = 'FETCH_RECOMMENDATION_SUCCESS';

export const EINSTEIN_RECOMMENDATION_STRATEGIES = {
  SIMILAR_PRODUCTS: 'product-to-product',
  RECENTLY_VIEWED: 'viewed-recently',
  PRODUCTS_IN_A_CATEGORY: 'products-in-a-category',
  COMPLETE_THE_SET: 'complete-the-set',
};

export const GEN_AI_STRATEGY = 'genai';

export const RECOMMENDATION_ENGINES = {
  EINSTEIN: 'einstein',
  GEN_AI: 'genAi',
};

export const FIELD_LIST = [
  'product_name',
  'productid',
  'min_offer_price',
  'min_list_price',
  'max_offer_price',
  'max_list_price',
  'unbxd_imageUrl',
  'prodpartno',
  'list_of_attributes',
  'genderAgeGroup',
  'low_offer_price',
  'high_offer_price',
  'low_list_price',
  'high_list_price',
  'primaryBrand',
  'TCPCustomListPrice',
  'TCPCustomSalePrice',
  'productimage',
  'TCPPrimaryBrandUSStore',
  'TCPPrimaryBrandCanadaStore',
  'seo_token',
  'TCPPrimaryCategoryCanadaStore',
  'TCPPrimaryCategoryUSStore',
  'favoritedcount',
  'TCPBazaarVoiceRating',
  'TCPProductIndCanadaStore',
  'TCPProductIndUSStore',
  'TCPColor',
  'TCPBazaarVoiceReviewCount',
  'TCPMerchantTagUSStore',
  'TCPMerchantTagCanadaStore',
  'TCPStyleTypeUS',
  'TCPStyleTypeCA',
  'TCPStyleQTYUS',
  'TCPStyleQTYCA',
  'tcp_promo_price',
  'tcp_promotion_id',
];
